@if (mode() === 'signin') {
<form [formGroup]="signinForm" (ngSubmit)="submitSignin()" class="ft-auth__signin p-4">
  <div class="ft-content mb-4" [ngClass]="{ 'ft-anim-shake': errorMessage() }">
    <div class="ft-logo my-5"></div>
    <div class="ft-wrapper">
      <h1 class="text-center text-primary" i18n>Start session</h1>
      <div class="d-flex flex-column gap-2">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label i18n>Email</mat-label>
          <input type="email" matInput formControlName="email" maxlength="50" autofocus autocomplete="email" (focusout)="
                signinForm.patchValue({
                  email: this.signinForm.value.email.trim()
                })
              " />
          @if (signinForm.get('email')?.invalid) {
          <mat-error>{{
            appService.getErrorMessage(signinForm.get('email'))
            }}</mat-error>
          }
        </mat-form-field>
        @if (passwordVisible()) {
        <mat-form-field appearance="fill" class="w-100">
          <mat-label i18n>Password</mat-label>
          <input type="text" matInput formControlName="password" maxlength="100" autocomplete="off" />
          @if (!submitting()) {
          <button type="button" matSuffix mat-icon-button (click)="togglePasswordVisible()">
            <ft-icon name="eye--strike-through" class="ft-icon--2"></ft-icon>
          </button>
          }
          @if (signinForm.get('password')?.invalid) {
          <mat-error>{{
            appService.getErrorMessage(signinForm.get('password'))
            }}</mat-error>
          }
        </mat-form-field>
        } @else {
        <mat-form-field appearance="fill" class="w-100">
          <mat-label i18n>Password</mat-label>
          <input type="password" matInput formControlName="password" maxlength="100" autocomplete="current-password" />
          @if (!submitting()) {
          <button type="button" matSuffix mat-icon-button (click)="togglePasswordVisible()" i18n-title
            title="Toggle visibility">
            <ft-icon name="eye" class="ft-icon--2"></ft-icon>
          </button>
          }
          @if (signinForm.get('password')?.invalid) {
          <mat-error>{{
            appService.getErrorMessage(signinForm.get('password'))
            }}</mat-error>
          }
        </mat-form-field>
        }
        <div class="d-flex flex-column gap-3 mb-3">
          @if (!submitting()) {
          <a href="javascript://" (click)="forgotPassword()" class="text-center mb-3" i18n>Forgot your password?</a>
          }
          <button type="submit" mat-flat-button color="primary" [disabled]="!signinForm.valid || submitting()"
            style="min-width: 110px">
            @if (!submitting()) {
            <span i18n>Continue</span>
            } @else {
            <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
            }
          </button>
        </div>
        @if (appService.allowSignup) {
        <div class="text-center" style="font-size: var(--ft-text-font-size-md)">
          <div i18n>Not registered yet?</div>
          @if (!submitting()) {
          <a routerLink="/signup" class="ms-2" i18n>Register here</a>
          }
        </div>
        }
      </div>
    </div>
    <div class="ft-terms text-center mt-4">
      <a [href]="appUsagePolicy()" target="_system" i18n>Terms and conditions</a>
      <a [href]="dataProtectionPolicy()" target="_system" i18n>Privacy notice</a>
      <p class="mt-4" i18n>&copy; MePrestas 2025. All Rights Reserved.</p>
    </div>
  </div>
</form>
}
@if (mode() === 'signup') {
<form [formGroup]="signupForm" (ngSubmit)="submitSignup()" class="ft-auth__signup">
  <div [ngClass]="{ 'ft-anim-shake': errorMessage() }" class="mb-4 mb-lg-0">
    <div class="ft-logo my-5"></div>
    <div class="ft-wrapper">
      <div class="my-4">
        <h1 class="text-center text-primary" i18n>Create an account</h1>
        <p class="text-center text-muted" style="font-size: var(--ft-text-font-size-md)">
          <span i18n>Already have an account?</span>
          @if (!submitting()) {
          <a (click)="login()" class="ms-2" i18n>Sign in</a>
          }
        </p>
      </div>
      <div class="d-flex flex-column gap-2">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label i18n>Alias</mat-label>
          <input type="text" matInput formControlName="alias" maxlength="30" autofocus autocomplete="alias" />
          @if (signupForm.get('alias')?.invalid) {
          <mat-error>{{
            appService.getErrorMessage(signupForm.get('alias'))
            }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label i18n>Email</mat-label>
          <input type="email" matInput formControlName="email" maxlength="50" autofocus autocomplete="email" />
          @if (signupForm.get('email')?.invalid) {
          <mat-error>{{
            appService.getErrorMessage(signupForm.get('email'))
            }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label i18n>Country residence</mat-label>
          <mat-select formControlName="country">
            <mat-select-trigger>
              {{ signupForm.get('country')?.value.description }}
            </mat-select-trigger>
            @for (country of countries(); track country.id) {
            <mat-option [value]="country">{{
              country.description
              }}</mat-option>
            }
          </mat-select>
          @if (signupForm.get('country')?.invalid) {
          <mat-error>{{
            appService.getErrorMessage(signupForm.get('country'))
            }}</mat-error>
          }
        </mat-form-field>
        <div class="ft-password-field">
          @if (passwordVisible()) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label i18n>Password</mat-label>
            <input type="text" matInput formControlName="password" maxlength="100" autocomplete="off" />
            @if (!submitting()) {
            <button type="button" matSuffix mat-icon-button (click)="togglePasswordVisible()">
              <ft-icon name="eye--strike-through" class="ft-icon--2"></ft-icon>
            </button>
            }
            @if (signupForm.get('password')?.invalid) {
            <mat-error>{{
              appService.getErrorMessage(signupForm.get('password'))
              }}</mat-error>
            }
          </mat-form-field>
          } @else {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label i18n>Password</mat-label>
            <input type="password" matInput formControlName="password" maxlength="100"
              autocomplete="current-password" />
            @if (!submitting()) {
            <button type="button" matSuffix mat-icon-button (click)="togglePasswordVisible()" i18n-title
              title="Toggle visibility">
              <ft-icon name="eye" class="ft-icon--2"></ft-icon>
            </button>
            }
            @if (signupForm.get('password')?.invalid) {
            <mat-error>
              @if (signupForm.get('password')?.hasError('required')) {
              {{
              appService.getErrorMessage(signupForm.get('password'))
              }}
              } @else {
              <ng-container i18n>It must meet the security requirements</ng-container>
              }
            </mat-error>
            }
          </mat-form-field>
          }
          <div class="ft-password-field__instructions">
            <div class="ft-item gap-1" [ngClass]="
                  signupForm.get('password')?.hasError('minLength')
                    ? 'text-muted'
                    : 'text-success'
                ">
              <ft-icon [name]="
                    signupForm.get('password')?.hasError('minLength')
                      ? 'circle'
                      : 'check--circle'
                  " class="ft-icon--1" />
              <div i18n>Must contain at least 8 characters</div>
            </div>
            <div class="ft-item gap-1" [ngClass]="
                  signupForm.get('password')?.hasError('upperCase')
                    ? 'text-muted'
                    : 'text-success'
                ">
              <ft-icon [name]="
                    signupForm.get('password')?.hasError('upperCase')
                      ? 'circle'
                      : 'check--circle'
                  " class="ft-icon--1" />
              <div i18n>Must contain at least 1 capital letter</div>
            </div>
            <div class="ft-item gap-1" [ngClass]="
                  signupForm.get('password')?.hasError('lowerCase')
                    ? 'text-muted'
                    : 'text-success'
                ">
              <ft-icon [name]="
                    signupForm.get('password')?.hasError('lowerCase')
                      ? 'circle'
                      : 'check--circle'
                  " class="ft-icon--1" />
              <div i18n>Must contain at least 1 lowercase letter</div>
            </div>
            <div class="ft-item gap-1" [ngClass]="
                  signupForm.get('password')?.hasError('specialCharacter')
                    ? 'text-muted'
                    : 'text-success'
                ">
              <ft-icon [name]="
                    signupForm.get('password')?.hasError('specialCharacter')
                      ? 'circle'
                      : 'check--circle'
                  " class="ft-icon--1" />
              <div i18n>Must contain at least 1 special character</div>
            </div>
            <div class="ft-item gap-1" [ngClass]="
                  signupForm.get('password')?.hasError('number')
                    ? 'text-muted'
                    : 'text-success'
                ">
              <ft-icon [name]="
                    signupForm.get('password')?.hasError('number')
                      ? 'circle'
                      : 'check--circle'
                  " class="ft-icon--1" />
              <div i18n>Must contain 1 number</div>
            </div>
          </div>
        </div>
        @if (passwordVisible()) {
        <mat-form-field appearance="fill" class="w-100">
          <mat-label i18n>Confirm password</mat-label>
          <input type="text" matInput formControlName="confirmPassword" maxlength="100" autocomplete="off" />
          @if (!submitting()) {
          <button type="button" matSuffix mat-icon-button (click)="togglePasswordVisible()">
            <ft-icon name="eye--strike-through" class="ft-icon--2"></ft-icon>
          </button>
          }
          @if (signupForm.get('confirmPassword')?.invalid) {
          <mat-error>{{
            appService.getErrorMessage(signupForm.get('confirmPassword'))
            }}</mat-error>
          }
        </mat-form-field>
        } @else {
        <mat-form-field appearance="fill" class="w-100">
          <mat-label i18n>Confirm password</mat-label>
          <input type="password" matInput formControlName="confirmPassword" maxlength="100"
            autocomplete="current-password" />
          @if (!submitting()) {
          <button type="button" matSuffix mat-icon-button (click)="togglePasswordVisible()" i18n-title
            title="Toggle visibility">
            <ft-icon name="eye" class="ft-icon--2"></ft-icon>
          </button>
          }
          @if (signupForm.get('confirmPassword')?.invalid) {
          <mat-error>{{
            appService.getErrorMessage(signupForm.get('confirmPassword'))
            }}</mat-error>
          }
        </mat-form-field>
        }
      </div>
    </div>
    <mat-checkbox class="my-4" formControlName="termsAccepted" i18n>If you continue with the service, you agree to our <a [href]="appUsagePolicy()" target="_system">Terms and Conditions</a> and <a [href]="dataProtectionPolicy()" target="_system">Privacy Policies</a>.</mat-checkbox>
    <div class="text-center">
      <button type="submit" mat-flat-button color="primary" [disabled]="!signupForm.valid || submitting()"
        style="min-width: 250px">
        @if (!submitting()) {
        <span i18n>Sign up</span>
        } @else {
        <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
        }
      </button>
    </div>
  </div>
</form>
}
@if (mode() === 'change-password') {
<form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" class="ft-auth__change-password">
  <div [ngClass]="{ 'ft-anim-shake': errorMessage() }" class="mb-4 mb-lg-0">
    <div class="ft-logo my-5"></div>
    <div class="ft-wrapper mb-3">
      <div class="my-4">
        <h1 class="text-center text-primary" i18n>Change password</h1>
      </div>
      <div class="d-flex flex-column gap-2">
        <div class="ft-password-field">
          @if (passwordVisible()) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label i18n>Password</mat-label>
            <input type="text" matInput formControlName="newPassword" maxlength="100" autocomplete="off" />
            @if (!submitting()) {
            <button type="button" matSuffix mat-icon-button (click)="togglePasswordVisible()">
              <ft-icon name="eye--strike-through" class="ft-icon--2"></ft-icon>
            </button>
            }
          </mat-form-field>
          } @else {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label i18n>Password</mat-label>
            <input type="password" matInput formControlName="newPassword" maxlength="100"
              autocomplete="current-password" />
            @if (!submitting()) {
            <button type="button" matSuffix mat-icon-button (click)="togglePasswordVisible()" i18n-title
              title="Toggle visibility">
              <ft-icon name="eye" class="ft-icon--2"></ft-icon>
            </button>
            }
          </mat-form-field>
          }
          <div class="ft-password-field__instructions">
            <div class="ft-item gap-1" [ngClass]="
                  changePasswordForm.get('newPassword')?.hasError('minLength')
                    ? 'text-muted'
                    : 'text-success'
                ">
              <ft-icon [name]="
                    changePasswordForm.get('newPassword')?.hasError('minLength')
                      ? 'circle'
                      : 'check--circle'
                  " class="ft-icon--1" />
              <div i18n>Must contain at least 8 characters</div>
            </div>
            <div class="ft-item gap-1" [ngClass]="
                  changePasswordForm.get('newPassword')?.hasError('upperCase')
                    ? 'text-muted'
                    : 'text-success'
                ">
              <ft-icon [name]="
                    changePasswordForm.get('newPassword')?.hasError('upperCase')
                      ? 'circle'
                      : 'check--circle'
                  " class="ft-icon--1" />
              <div i18n>Must contain at least 1 capital letter</div>
            </div>
            <div class="ft-item gap-1" [ngClass]="
                  changePasswordForm.get('newPassword')?.hasError('lowerCase')
                    ? 'text-muted'
                    : 'text-success'
                ">
              <ft-icon [name]="
                    changePasswordForm.get('newPassword')?.hasError('lowerCase')
                      ? 'circle'
                      : 'check--circle'
                  " class="ft-icon--1" />
              <div i18n>Must contain at least 1 lowercase letter</div>
            </div>
            <div class="ft-item gap-1" [ngClass]="
                  changePasswordForm
                    .get('newPassword')
                    ?.hasError('specialCharacter')
                    ? 'text-muted'
                    : 'text-success'
                ">
              <ft-icon [name]="
                    changePasswordForm
                      .get('newPassword')
                      ?.hasError('specialCharacter')
                      ? 'circle'
                      : 'check--circle'
                  " class="ft-icon--1" />
              <div i18n>Must contain at least 1 special character</div>
            </div>
            <div class="ft-item gap-1" [ngClass]="
                  changePasswordForm.get('newPassword')?.hasError('number')
                    ? 'text-muted'
                    : 'text-success'
                ">
              <ft-icon [name]="
                    changePasswordForm.get('newPassword')?.hasError('number')
                      ? 'circle'
                      : 'check--circle'
                  " class="ft-icon--1" />
              <div i18n>Must contain 1 number</div>
            </div>
          </div>
        </div>
        <mat-form-field appearance="fill" class="ft-form-field--nolabel w-100">
          <mat-label i18n>Confirm password</mat-label>
          <input type="password" matInput formControlName="confirmPassword" maxlength="100" />
          @if (changePasswordForm.get('confirmPassword')?.invalid) {
          <mat-error>{{
            appService.getErrorMessage(
            changePasswordForm.get('confirmPassword'),
            { notEqual: notEqualMessage }
            )
            }}</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="text-center">
      <button type="submit" mat-flat-button color="primary" [disabled]="!changePasswordForm.valid || submitting()"
        style="min-width: 250px">
        @if (!submitting()) {
        <span i18n>Submit</span>
        } @else {
        <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
        }
      </button>
    </div>
  </div>
</form>
}
<div class="ft-auth__info">
  <div class="ft-logo my-5 d-md-none"></div>
  <div class="ft-label px-5">
    <div class="ft-label__title" i18n>Take control of your finances with MePrestas</div>
    <div class="ft-label__subtitle" i18n>MePrestas is an innovative financial alternative for managing loans quickly, easily, and securely.</div>
  </div>
  <div class="text-center d-md-none">
    <a
      (click)="login()"
      mat-flat-button
      color="primary"
      class="ms-2"
      style="
        min-width: 60vw;
        font-size: 1.125rem;
        height: unset;
        line-height: 40px;
        margin-bottom: 1.5rem;
      " i18n>Enter</a>
  </div>
  <div class="ft-image"></div>
</div>
@if (mode() === '') {
<div class="ft-image-mobile d-block d-md-none"></div>
}
<ng-template #submittingTemplate>
  <div class="text-center">
    <ft-progress class="ft-progress--2"></ft-progress>
  </div>
</ng-template>
<ng-template #signupConfirmationTemplate>
  <div mat-dialog-content class="text-center">
    <div class="ft-icon ft-icon--lead ft-icon--3 my-5">
      <svg viewBox="0 0 24 24" style="
          width: 1em;
          height: 1em;
          vertical-align: middle;
          fill: currentColor;
          display: inline-block;
          font-size: 2rem;
        ">
        <path stroke="currentColor" stroke-width="2" d="M19.5 6.5l-10 10-5-5" fill="none" />
      </svg>
    </div>
    <h2 i18n>Account Activated</h2>
    <div i18n>Your account is now active! You can now log in using your email and password.</div>
  </div>
  <div #actionsElement mat-dialog-actions class="justify-content-center">
    <button type="button" mat-stroked-button mat-dialog-close i18n>Close</button>
  </div>
</ng-template>
